import { render, staticRenderFns } from "./SelectProjectCompany.vue?vue&type=template&id=fdd66570&"
import script from "./SelectProjectCompany.vue?vue&type=script&lang=ts&"
export * from "./SelectProjectCompany.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports